module.exports = __webpack_public_path__ + "img/pIndex-m-slide2.8f715180.jpg";